export function MinusIcon({ ...props }) {
  return (
    <svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.75 6.5c0 .1-.03.195-.085.265a.26.26 0 0 1-.207.11H3.042a.26.26 0 0 1-.207-.11.44.44 0 0 1-.085-.265c0-.1.03-.195.085-.265a.26.26 0 0 1 .207-.11h6.416c.078 0 .152.04.207.11s.085.166.085.265"
        fill="currentColor"
      />
    </svg>
  );
}
